import React from 'react';
import { ExclamationTriangleIcon, InformationCircleIcon, LightBulbIcon } from '@heroicons/react/24/outline';

/**
 * AIInsights component displays AI-generated insights and alerts
 * for the RAG chatbot system based on data analysis.
 */
const AIInsights = ({ insights, className = '' }) => {
  // Function to get the appropriate styling based on insight type
  const getInsightStyling = (type) => {
    switch (type) {
      case 'warning':
        return {
          icon: <ExclamationTriangleIcon className="h-5 w-5 text-red-500" />,
          bgColor: 'bg-red-900/30',
          borderColor: 'border-red-800/50',
          textColor: 'text-red-400'
        };
      case 'info':
        return {
          icon: <InformationCircleIcon className="h-5 w-5 text-blue-500" />,
          bgColor: 'bg-blue-900/30',
          borderColor: 'border-blue-800/50',
          textColor: 'text-blue-300'
        };
      case 'alert':
        return {
          icon: <ExclamationTriangleIcon className="h-5 w-5 text-orange-500" />,
          bgColor: 'bg-orange-900/30',
          borderColor: 'border-orange-800/50',
          textColor: 'text-orange-300'
        };
      default:
        return {
          icon: <LightBulbIcon className="h-5 w-5 text-green-500" />,
          bgColor: 'bg-green-900/30',
          borderColor: 'border-green-800/50',
          textColor: 'text-green-300'
        };
    }
  };

  return (
    <div className={`sm-card p-6 ${className}`}>
      <h2 className="text-lg font-semibold text-white mb-4">
        <span className="flex items-center">
          <LightBulbIcon className="h-5 w-5 text-yellow-500 mr-2" />
          AI Insights & Alerts
        </span>
      </h2>
      
      <div className="space-y-3">
        {insights.map((insight, index) => {
          const styling = getInsightStyling(insight.type);
          
          return (
            <div 
              key={index} 
              className={`${styling.bgColor} ${styling.borderColor} border rounded-lg p-3 flex items-center`}
            >
              <div className="mr-3">
                {styling.icon}
              </div>
              <p className={`text-sm ${styling.textColor}`}>{insight.message}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AIInsights;
